import { useState, useEffect } from "react";
import { formatTime } from "./data";

interface CountdownTimerProps {
  storedCurrentSessionStartTime: number; // Timestamp in ms
  onEnd: () => Promise<any>;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  storedCurrentSessionStartTime,
  onEnd,
}) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    const TEN_MINUTES_MS = 10 * 60 * 1000;
    const sessionEndTime = storedCurrentSessionStartTime + TEN_MINUTES_MS;
    let interval: NodeJS.Timeout | undefined;
    let requestCalled = false;

    const updateTimer = () => {
      const remainingMs = sessionEndTime - Date.now();
      const remainingSeconds = Math.max(0, Math.floor(remainingMs / 1000));
      setTimeLeft(remainingSeconds);

      if (remainingMs <= 0 && !requestCalled) {
        requestCalled = true;
        clearInterval(interval);
        onEnd().catch((err) => {
          console.error("API request failed:", err);
        });
      }
    };

    updateTimer(); // Call immediately
    interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [storedCurrentSessionStartTime, onEnd]);

  return (
    <div>
      <span className="hidden lg:inline">Time Left:</span>{" "}
      {formatTime(timeLeft)}
    </div>
  );
};

export default CountdownTimer;
